import { tVProgramClosed } from '@kinopoisk-int/evgen-web-events/web/tv_program';

import { useEventCallback } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback';

import { buildChannelProgramModalParams } from '../builders/channel-program-modal-params-builder';

interface Options {
    channelId: string;
}
export function useChannelProgramClosed(uiParams: Options) {
    const handleClosed = useEventCallback({
        event: tVProgramClosed,
        eventParamsBuilder: buildChannelProgramModalParams,
        uiParams,
    });

    return handleClosed;
}
